// Хөгжил (сурагч) — хичээлээс гадуурх миний зам: Passion Program (сонголт + миний хөтөлбөр), хаус (лого, оноо; ерөнхийлөгчид ирц),
// зөвлөгөө, их сургуулийн өргөдөл (11-р анги). Өмнө нь цэсэнд тус тусдаа байсан хуудсууд энд холбогдоно — юу ч хасагдаагүй.
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight, FiCompass, FiBookOpen, FiFlag } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";
import { AuthContext } from "contexts";
import PassionIcon from "components/PassionIcon";
import { HouseMark } from "components/brand";

const isG11 = (g) => String(g || "").trim() === "11";

function Row({ to, icon, title, sub }) {
  return (
    <Link to={to} className="tj-card p-4 flex items-center gap-3 !text-[#1c1c1c] hover:bg-[#faf7ff]">
      <span className="h-11 w-11 rounded-xl bg-[#f3eeff] text-primary flex items-center justify-center shrink-0">{icon}</span>
      <span className="flex-1 min-w-0"><span className="block font-bold">{title}</span><span className="block text-xs text-[#6e5e8a]">{sub}</span></span>
      <FiChevronRight className="text-primary shrink-0" />
    </Link>
  );
}

export default function Growth() {
  const { state } = useContext(AuthContext);
  const [prof, setProf] = useState({});
  const me = { ...(state.studentInfo?.profile || {}), ...prof }; // housePresident, grade — серверээс шинэ
  const [pp, setPp] = useState(null);
  const [st, setSt] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: "/applicant/profile", silent: true }).then((r) => setProf(r.data || {})).catch(() => {});
    instance({ method: "get", url: "/student/passion/me", silent: true }).then((r) => setPp(r.data)).catch(() => setPp(false));
    instance({ method: "get", url: "/student/profile", silent: true }).then((r) => setSt(r.data || {})).catch(() => setSt({}));
  }, []);
  const mine = (pp?.programs || []).filter((p) => p.mine);
  const open = pp && ["first", "second"].includes(pp.phase);
  const house = st?.house;

  return (
    <div className="pt-4 md:pt-8 pb-8 max-w-3xl mx-auto w-full flex flex-col gap-4">
      <div>
        <h1 className="m-0 text-[26px] md:text-[32px] font-extrabold text-primary leading-tight">Хөгжил</h1>
        <p className="m-0 mt-1 text-sm text-[#6e5e8a]">Хичээлээс гадуурх миний зам</p>
      </div>

      {pp && !pp.programs?.length && (
        <section className="rounded-2xl p-4 text-white flex flex-col gap-2" style={{ background: "linear-gradient(135deg, #5c1090, #8b2fd1)" }}>
          <span className="text-[11px] font-bold tracking-wider text-white/75">PASSION PROGRAM</span>
          <span className="text-lg font-bold leading-snug">Дугуйлангийн сонголт удахгүй нээгдэнэ</span>
          <span className="flex -space-x-2">{["basketball", "volleyball", "bjj", "fitness", "drama", "calligraphy"].map((k) => <span key={k} className="rounded-2xl ring-2 ring-[#7a2bc0]"><PassionIcon icon={k} size={40} /></span>)}</span>
          <span className="text-sm text-white/85">Нээгдэхэд мэдэгдэл ирнэ.</span>
        </section>
      )}
      {pp && pp.programs?.length > 0 && (
        <Link to="/passion" className="rounded-2xl p-4 text-white flex flex-col gap-2 !text-white" style={{ background: "linear-gradient(135deg, #5c1090, #8b2fd1)" }}>
          <span className="text-[11px] font-bold tracking-wider text-white/75">PASSION PROGRAM{pp.round ? ` · ${pp.round.name}` : ""}</span>
          <span className="text-lg md:text-xl font-bold leading-snug">
            {open ? `Бүртгэл нээлттэй — ${pp.limit} хүртэл хөтөлбөрт бүртгүүл` : pp.phase === "soon" ? `Бүртгэл ${dayjs(pp.round.opensAt).format("MM/DD HH:mm")}-д нээгдэнэ` : "Хөтөлбөрүүдтэй танилцах"}
          </span>
          <span className="flex -space-x-2">{pp.programs.slice(0, 6).map((p) => <span key={p.id} className="rounded-2xl ring-2 ring-[#7a2bc0]"><PassionIcon icon={p.icon} size={40} /></span>)}</span>
          <span className="self-start pchip bg-white !text-primary border-white font-bold mt-1">{open ? "Бүртгүүлэх" : "Харах"}</span>
        </Link>
      )}

      {mine.length > 0 && (
        <section className="tj-card p-4 flex flex-col gap-3">
          <h2 className="m-0 text-base font-bold">Миний хөтөлбөр</h2>
          {mine.map((p) => {
            const s = p.sessions.find((x) => x.id === p.mine.sessionId);
            const tag = { pending: "Баталгаажуулалт хүлээж буй", seated: "Суудалтай", confirmed: "Баталгаажсан", waitlist: `Хүлээлэгт · ${p.mine.position}-рт`, interest: "Сонирхол бүртгэсэн" }[p.mine.status];
            return (
              <Link key={p.id} to={`/passion?p=${p.id}`} className="flex items-center gap-3 !text-[#1c1c1c]">
                <PassionIcon icon={p.icon} size={44} />
                <span className="flex-1 min-w-0"><span className="block font-bold text-sm">{p.name}</span><span className="block text-xs text-[#6e5e8a]">{s ? `${s.label} · ${s.when}` : p.location || ""}</span></span>
                <span className="text-[11px] font-bold rounded-full px-2 py-0.5 bg-[#f3eeff] text-primary">{tag}</span>
              </Link>
            );
          })}
        </section>
      )}

      {house && (
        <Link to={me.housePresident ? "/house" : "/growth"} className="tj-card p-4 flex items-center gap-3 !text-[#1c1c1c]">
          <HouseMark house={house.name || st.houseId} size={56} />
          <span className="flex-1 min-w-0">
            <span className="block font-bold">Миний хаус · {house.monName || house.name}</span>
            <span className="block text-xs text-[#6e5e8a]">{Intl.NumberFormat().format(house.point || 0)} оноо{house.place ? ` · ${house.place}-р байр` : ""}{me.housePresident ? " · ирц бүртгэх" : ""}</span>
          </span>
          {me.housePresident && <FiChevronRight className="text-primary shrink-0" />}
        </Link>
      )}

      <div className="grid gap-3 md:grid-cols-2">
        <Row to="/counseling" icon={<FiCompass size={20} />} title="Зөвлөгөө" sub="Зөвлөхтэй уулзах цаг авах" />
        {isG11(me.grade) && <Row to="/college-prep" icon={<FiBookOpen size={20} />} title="Их сургуулийн өргөдөл" sub="Өргөдлийн бэлтгэл, тайлан" />}
        {me.housePresident && <Row to="/house" icon={<FiFlag size={20} />} title="Хаусын ирц" sub="Хаусын ерөнхийлөгч" />}
      </div>
    </div>
  );
}
